module.exports = __webpack_public_path__ + "static/img/babyClaimMobile.5be9546.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/babyVX/assets/babyClaimMobile.png
// module id = wA8e
// module chunks = 1